import React from 'react'

class ThemesSection extends React.Component {
  state = {}

  componentDidMount () {}

  render () {
    var content = <div>Themes section</div>

    return content
  }
}

module.exports = ThemesSection
